import { takeEvery, fork, put, all, call } from "redux-saga/effects";

import {
  apiError,
  getEmissionnorms,
  emissionnormsListSuccessful,
  emissionnormsAddSuccessful,
  isModelVisible,
} from "./emissionnormsSlice";

// AUTH related methods
import {
  postAdd,
  getParamsList,
  postEdit,
  postDelete,
} from "../../../helpers/Helper";
import { Modal } from "antd";
import {
  RiCheckboxCircleLine,
  RiAlertLine,
  RiInformationLine,
} from "react-icons/ri";

function* getEmissionnorm({ payload }) {
  var data = payload;
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] != "" && k != null && k != "no_of_pages") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/masters/emissionnorms/", params);
    yield put(emissionnormsListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* AddEmissionnorms({ payload }) {
  try {
    if (payload.id == 0) {
      const response = yield call(postAdd, "/masters/emissionnorms/", payload);
      if (response.status === 201) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Emission Norms Add Successfully.!
              </p>
            </div>
          ),
        });
        yield put(getEmissionnorms({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to added Emission Norms. Please try again!
              </p>
            </div>
          ),
        });
      }
      yield put(emissionnormsAddSuccessful(null));
    } else {
      const response = yield call(
        postEdit,
        "/masters/emissionnorms/" + payload.id,
        payload
      );
      if (response.status === 200) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Emission Norms Edited Successfully.!
              </p>
            </div>
          ),
        });
        yield put(getEmissionnorms({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to edit Emission Norms. Please try again!
              </p>
            </div>
          ),
        });
      }
      yield put(emissionnormsAddSuccessful(null));
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });
    yield put(apiError(error));
  }
}

function* DeleteEmissionnorms({ payload }) {
  // var countryID = payload;
  try {
    const response = yield call(postDelete, "/masters/emissionnorms/" + payload);

    if (response.status === 204) {
      Modal.success({
        icon: (
          <span className="remix-icon">
            <RiCheckboxCircleLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Your Emission Norms Edited Successfully.!
            </p>
          </div>
        ),
      });
      yield put(getEmissionnorms({ page: 1, search: "", page_size: 10 }));
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Unable to edit Emission Norms. Please try again!
            </p>
          </div>
        ),
      });
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });

    yield put(apiError(error));
  }
}

export function* watchgetEmissionnorms() {
  yield takeEvery("emissionnorms/getEmissionnorms", getEmissionnorm);
}
export function* watchEmissionnormsAdd() {
  yield takeEvery("emissionnorms/emissionnormsAdd", AddEmissionnorms);
}

export function* watchEmissionnormsDelete() {
  yield takeEvery("emissionnorms/emissionnormsDelete", DeleteEmissionnorms);
}

function* EmissionnormsSaga() {
  yield all([
    fork(watchgetEmissionnorms),
    fork(watchEmissionnormsAdd),
    fork(watchEmissionnormsDelete),
  ]);
}

export default EmissionnormsSaga;
